module.exports = __webpack_public_path__ + "static/media/card-orange.8384a593.png";